export const LICENSE_TIERS = ['FREE_TIER', 'STARTER_TIER', 'PRO_TIER', 'TRIAL_TIER'];
export const DefaultLicenseTier = 'FREE_TIER';
export const LICENSE_FEATURES = [
    'aiModeration',
    'payments',
    'maxUsers',
    'importExport',
    'customDomain',
    'mobileApp',
    'cmsIntegration',
    'emailIntegration'
];
export const LicenseFeatureMatrix = {
    TRIAL_TIER: {
        aiModeration: false,
        payments: false,
        maxUsers: 50,
        importExport: false,
        customDomain: false,
        mobileApp: false,
        cmsIntegration: false,
        emailIntegration: false
    },
    FREE_TIER: {
        aiModeration: false,
        payments: false,
        maxUsers: 500,
        importExport: false,
        customDomain: false,
        mobileApp: false,
        cmsIntegration: false,
        emailIntegration: false
    },
    STARTER_TIER: {
        aiModeration: false,
        payments: false,
        maxUsers: 2000,
        importExport: false,
        customDomain: true,
        mobileApp: false,
        cmsIntegration: false,
        emailIntegration: true
    },
    PRO_TIER: {
        aiModeration: true,
        payments: true,
        maxUsers: 100000,
        importExport: true,
        customDomain: true,
        mobileApp: true,
        cmsIntegration: true,
        emailIntegration: true
    }
};
/**
 * Custom typeguard for LicenseTier
 * @param { string } type the license tier to validate
 * @returns { boolean } true if the tier is a valid license tier
 */
export function isLicenseTier(type) {
    return LICENSE_TIERS.includes(type);
}
/**
 * Get a feature boolean flag or number (for maxUsers)
 * @param { LicenseTier } tier the tier to get from
 * @param { LicenseFeature } feature the feature to get
 * @returns { number | boolean } the value of the liscense feature in the tier matrix
 */
export function getLicenseTierFeature(tier, feature) {
    return LicenseFeatureMatrix[tier][feature];
}
